import { render, staticRenderFns } from "./SectionTable.vue?vue&type=template&id=47671f51"
import script from "./SectionTable.vue?vue&type=script&lang=js"
export * from "./SectionTable.vue?vue&type=script&lang=js"
import style0 from "./SectionTable.vue?vue&type=style&index=0&id=47671f51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports